import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './alphabet-card.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class AlphabetCard extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      letter: { type: String },
      linkGroup: { type: Array },
      links: { type: Array },
      noResults: { type: String },
      title: { type: String },
    };
  }

  constructor() {
    super();
    this.letter = '';
    this.linkGroup = [];
  }

  firstUpdated() {
    const linkGroup = [];

    if (this.links.length < 17) {
      while (this.links.length > 0) linkGroup.push(this.links.splice(0, 8));
    } else {
      linkGroup.push(this.links.splice(0, Math.ceil(this.links.length / 2)));
    }
    this.linkGroup = linkGroup;
    this.requestUpdate();
  }

  render() {
    return html`
      <div id="alphabet-${this.letter}" class="alphabet-card__wrapper">
        <div class="alphabet-card__letter"><span>${this.letter}</span></div>
        <nav class="alphabet-card__nav" role="navigation" title="${this.title}">
          ${this.linkGroup.length
            ? html`
                ${this.linkGroup.map(group => {
                  return html`
                    <ul
                      class="${classMap({
                        'alphabet-card__list': true,
                      })}"
                    >
                      ${group.map(link => {
                        return html`<li class="alphabet-card__item">
                          <a
                            href=${link.url}
                            target="_self"
                            class="${classMap({
                              'active': !!link.active,
                              'alphabet-card__link': true,
                            })}"
                          >
                            ${link.text}
                          </a>
                        </li>`;
                      })}
                    </ul>
                  `;
                })}
              `
            : html` <div class="alphabet-card__no-results">
                ${this.noResults}
              </div>`}
        </nav>
      </div>
    `;
  }
}
customElements.define('hf-alphabet-card', AlphabetCard);
